import loadJS from 'load-js'

import { isLocalEnv } from './env'

export const dependencies = [
    {
        // HubSpot
        text: (
            `(function(w,d,s,p,i){window.hsConversationsSettings=p;var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s);j.async=true;j.src='https://js.hs-scripts.com/'+i+'.js';
            f.parentNode.insertBefore(j,f);})(window,document,'script',{loadImmediately:false},5756448);`
        ),
        removeInLocalEnv: true
    },
    {
        // OneSignal
        url: 'https://cdn.onesignal.com/sdks/OneSignalSDK.js',
        async: true,
        removeInLocalEnv: true
    },
    {
        // Dropbox
        url: 'https://www.dropbox.com/static/api/2/dropins.js',
        async: true
    },
    {
        // Google Tag Manager
        text: (
            `dataLayer=[];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5393TWM');`
        ),
        skipInMockRun: true
    },
    {
        // Woopra
        text: (
            `!function(){var t,o,c,e=window,n=document,r=arguments,a="script",i=["call",
            "cancelAction","config","identify","push","track","trackClick","trackForm",
            "update","visit"],s=function(){var t,o=this,c=function(t){o[t]=function(){
            return o._e.push([t].concat(Array.prototype.slice.call(arguments,0))),o}};
            for(o._e=[],t=0;t<i.length;t++)c(i[t])};for(e.__woo=e.__woo||{},t=0;t<r.length;
            t++)e.__woo[r[t]]=e[r[t]]=e[r[t]]||new s;(o=n.createElement(a)).async=1,
            o.src="https://static.woopra.com/js/w.js",(c=n.getElementsByTagName(a)[0])
            .parentNode.insertBefore(o,c)}("woopra");
            `
        ),
        skipInMockRun: true
    },
    {
        // Calendly
        url: 'https://assets.calendly.com/assets/external/widget.js'
    }
]

export default function loadDependencies() {
    const isMockRun = (() => {
        // Dev-harness only: never let `?mock=1` alter dependency loading in a production build.
        if (process.env.NODE_ENV === 'production') return false
        try { return new URLSearchParams(window.location.search).get('mock') === '1' } catch { return false }
    })()
    const selected = (isLocalEnv
        ? dependencies.filter(d => !d.removeInLocalEnv)
        : dependencies
    ).filter(d => !(isMockRun && d.skipInMockRun))
    loadJS(selected).catch(err => console.warn('Fail on loading dependency', err))
}
